import type { FC } from 'react';
import { QueueCollectionWrapper } from './Queue.styled';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dracula } from 'react-syntax-highlighter/dist/esm/styles/prism';


interface QueueCollectionProps { }

const QueueCollection: FC<QueueCollectionProps> = () => (
   <QueueCollectionWrapper>
      <header className="entry-header">
         <h1 className="entry-title" itemProp="headline">Queue</h1>
      </header>
      <br/>
      <div className="entry-content clear" itemProp="text" style={{ height: 'auto !important' }}>
         <p className="text-align-justify">The queue interface maintains the first-in-first-out FIFO order. A queue is an ordered list. For instance, classes like PriorityQueue, Deque, and ArrayDeque implements the Queue interface.</p>
         <br/>
         <h4 className="text-align-justify">Syntax :</h4>
         <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
            {
               'Queue q1 = new PriorityQueue();\n' +
               'Queue q2 = new ArrayDeque();\n' +
               'Queue q3 = new Deque();'
            }
         </SyntaxHighlighter>
         <br/>
         <h4 className="text-align-justify">Types of Queue :</h4>
         <ul className="text-align-justify">
            <li><strong>PriorityQueue :</strong>
               <ul>
                  <li>The PriorityQueue class implements the Queue interface.</li>
                  <li>In addition, it holds the elements or objects to process them by their priorities.</li>
                  <li>However, PriorityQueue doesn’t allow us to store null values in the queue.</li>
                  <li>Eg :
                     <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
                        {
                           'PriorityQueue queue = new PriorityQueue();\n' +
                           'queue.add(“Ram”);'
                        }
                     </SyntaxHighlighter>
                  </li>
               </ul>
            </li>
            <br/>
            <li><strong>Deque :</strong>
               <ul>
                  <li>Deque interface extends the Queue interface.</li>
                  <li>It implements both LIFO and FIFO.</li>
                  <li>Deque stands for a double-ended queue.</li>
                  <li>In other words, it enables us to remove and add the elements from both the side.</li>
                  <li>Eg :
                     <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
                        {
                           'Deque d = new ArrayDeque();'
                        }
                     </SyntaxHighlighter>
                  </li>
               </ul>
            </li>
            <br/>
            <li><strong>ArrayDeque :</strong>
               <ul>
                  <li>ArrayDeque class implements the Deque interface.</li>
                  <li>It is faster than ArrayList and Stack and has no capacity restrictions.</li>
                  <li>Eg :
                     <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
                        {
                           'Deque deque = new ArrayDeque();\n' +
                           'deque.add(“Ram”);'
                        }
                     </SyntaxHighlighter>
                  </li>
               </ul>
            </li>
         </ul>
      </div>
   </QueueCollectionWrapper>
);

export default QueueCollection;
